import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actionCreators as QualityActions } from '../actions/QualityActions';
import { defaultQualityState } from '../models/QualityState';

export const qualityReducer = reducerWithInitialState(defaultQualityState)
	.case(QualityActions.setAvailable, (state, available) => ({ ...state, available }))
	.case(QualityActions.setLevels, (state, levels) => ({ ...state, levels }))
	.case(QualityActions.setSelection, (state, payload) => ({ ...state, auto: payload.auto, currentLevel: payload.currentLevel }));
